require('./').polyfill()



//////////////////
// WEBPACK FOOTER
// ./node_modules/raf/polyfill.js
// module id = 767
// module chunks = 1